import React, { Component } from 'react';
import { connect } from 'react-redux';
import Paper from 'material-ui/Paper';
import Snackbar from 'material-ui/Snackbar';
import { setTitle } from '../actions/topbar.actions';
import * as authActions from '../actions/auth.actions';

const style = {
  container: {
    width: '100%',
    height: '100%',
    position: 'relative',
  },
  paper: {
    margin: 0,
    padding: 40,
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },
};

class Login extends Component {
  static contextTypes = {
    router: React.PropTypes.object,
  };

  state = {
    snackBarOpen: false,
  };

  componentWillMount() {
    const { routeParams } = this.props;
    const token = routeParams.token;

    this.props.signInWithToken(token);
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextProps.auth.authenticated) {
      this.context.router.push('/');
      return false;
    }

    return true;
  }

  render() {
    const { auth: { authenticating, error } } = this.props;
    const errorMessage = (error && error.message) || '';

    return (
      <div>
        <Paper style={style.paper} zDepth={3}>
          Authenticating...
        </Paper>
        <Snackbar
          open={error !== null}
          message={errorMessage}
          autoHideDuration={4000}
          onRequestClose={this.props.clearLoginError}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    auth: state.auth,
  };
}

export default connect(mapStateToProps, { setTitle, ...authActions })(Login);



// WEBPACK FOOTER //
// ./src/pages/TokenLogin.js